import { render, staticRenderFns } from "./BankAccountEditor.vue?vue&type=template&id=3c855e15&scoped=true"
import script from "./BankAccountEditor.vue?vue&type=script&lang=js"
export * from "./BankAccountEditor.vue?vue&type=script&lang=js"
import style0 from "./BankAccountEditor.vue?vue&type=style&index=0&id=3c855e15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c855e15",
  null
  
)

export default component.exports